<template>
  <div>
    <div class="card">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'attr_key' | t }}</th>
            <th>{{ 'attr_value' | t }}</th>
            <th class="text-right">{{ 'is_public' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(attr, i) in global_attrs" ref="global_attr_list">
            <td>
              <input class="form-control" v-model="attr.attr_key" />
            </td>
            <td>
              <input class="form-control" v-model="attr.attr_value" />
            </td>
            <td class="text-right">
              <input class="form-check-input" type="checkbox" v-model="attr.is_public" />
            </td>
            <td class="text-right">
              <button class="btn btn-sm btn-outline-danger" v-on:click="removeGlobalAttr(i)">{{ 'delete' | t }}</button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="text-right" colspan="4">
              <button class="btn btn-primary" v-on:click="addGlobalAttr">{{ 'add_global_attr' | t }}</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts from '@/utils/alerts';

export default {
  props: { value: Array },
  data: function () {
    return {
      global_attrs: this.value
    };
  },
  methods: {
    addGlobalAttr: function (attr) {
      this.global_attrs.push({
        attr_key: '',
        attr_value: '',
        is_public: false
      });
      this.$emit('input', this.global_attrs);
    },
    removeGlobalAttr: function (i) {
      this.global_attrs.splice(i, 1);
      this.$emit('input', this.global_attrs);
    }
  }
};
</script>
